module.exports = __webpack_public_path__ + "img/ms.ecd3b127.jpg";